import {Footer} from '@/app/layout/footer/footer';
import {Navbar} from '@/app/layout/navbar/navbar';
import {FeaturesService} from '@/app/features/services/features.service';
import {CertificateVerify as CertificateVerifyModel} from '@/app/shared/models/course-model';
import {CommonModule} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';

/**
 * Pagina publica que abre el QR del certificado: muestra los datos y si sigue vigente.
 * Tambien permite escribir el record locator a mano.
 */
@Component({
    selector: 'app-certificate-verify',
    imports: [CommonModule, FormsModule, Navbar, Footer, TranslatePipe,
        MatButtonModule, MatFormFieldModule, MatIconModule, MatInputModule],
    templateUrl: './certificate-verify.html',
    styleUrl: './certificate-verify.scss'
})
export class CertificateVerify implements OnInit {

    certificate?: CertificateVerifyModel;
    state: 'search' | 'loading' | 'found' | 'not-found' = 'search';
    searchCode = '';
    today = new Date();

    constructor(private route: ActivatedRoute, private router: Router, private featuresService: FeaturesService) {
    }

    ngOnInit(): void {
        // al cambiar el codigo en la url se vuelve a consultar
        this.route.paramMap.subscribe(params => {
            const code = params.get('code');
            if (code) {
                this.searchCode = code;
                this.verify(code);
            } else {
                this.state = 'search';
            }
        });
    }

    verify(code: string): void {
        this.state = 'loading';
        this.featuresService.verifyCertificate(code).subscribe({
            next: (res) => {
                this.certificate = res.result;
                this.state = this.certificate ? 'found' : 'not-found';
            },
            error: () => {
                this.certificate = undefined;
                this.state = 'not-found';
            }
        });
    }

    onSearch(): void {
        const code = this.searchCode?.trim().toUpperCase();
        if (code) {
            this.router.navigate(['/certificate', code]);
        }
    }
}
